import { useMutation } from "@tanstack/react-query";
import type { ExtendedFirebaseUser } from "../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { IntercomUpdateCurrentBusinessType } from "@sellar-io/api-v2/types";

export const useIntercomUpdateCurrentBusiness = (
  user: ExtendedFirebaseUser | undefined,
) => {
  return useMutation({
    mutationFn: (request: { data: IntercomUpdateCurrentBusinessType }) =>
      apiV2Request({
        user,
        business: null,
        method: "post",
        path: `intercom/current-business`,
        data: request.data,
      }).then((response) => apiV2AssertResponse(response).data as void),
  });
};
